import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import CurrencyFormat from "react-currency-format";
import { useTranslation } from "react-i18next";

//import lib
import isEmpty from "../../lib/isEmpty";
import { toFixedDown, truncateDecimals } from "../../lib/roundOf";
import ExchangeModal from "./ExchangeModal";
// import { currencyChange } from "../../lib/pairHelper";
import { toastAlert, textCopy } from "../../utils/toast";
import Deposit from "../Deposit/Deposit";
import Withdraw from "../Withdraw/Withdraw";
import { Dropdown, Image } from "react-bootstrap";

const initialFormValue = {
  isModalOpen: false,
  record: {},
};

const WalletDetails = () => {
  //redux
  const currency = useSelector((state) => state.currency);
  const walletData = useSelector((state) => state.wallet);
  const priceConversion = useSelector((state) => state.priceconversion);
  // const { defaultcurrency } = useSelector((state) => state.account);
  const defaultcurrency = "USD";

  const history = useNavigate();
  const { t, i18n } = useTranslation();

  //state
  const [showBalance, setshowBalance] = useState(false);
  const [totalUSD, setTotalUSD] = useState(0);
  const [Wallet, setWallet] = useState([]);
  const [check, setCheck] = useState(false);
  const [filter, setFilter] = useState(true);
  const [exchangeData, setExhangeData] = useState(initialFormValue);
  const [loader, setLoading] = useState(true);
  const [PriceChange, setPriceChange] = useState();
  const [options, setOption] = useState([])
const [activeTab, setActiveTab] = useState("deposit"); // default active tab
const [selectedOption, setSelectedOption] = useState();
  //function
  const handleSearch = (e) => {
    let { name, value } = e.target;
    function getSearch(item) {
      return (
        item.coin.toLowerCase() == value?.toLowerCase() ||
        item.balance == value ||
        item.USDValue == value
      );
    }
    let filterDoc = Wallet.filter(getSearch);
    if (!isEmpty(filterDoc)) {
      setWallet(filterDoc);
      setFilter(true);
    } else {
      setFilter(false);
    }

    if (isEmpty(value)) {
      handleAsset();
      setFilter(true);
    }
  };

  const handleAsset = () => {
    try {
      let totalAmount = 0;
      let tempArr = [...walletData];
      currency?.length >= 0 &&
        currency.map((item, index) => {
          let PriceCnv = priceConversion.find(
            (el) =>
              (el.baseSymbol == item.currencySymbol &&
                el.convertSymbol == "USD") ||
              (el.baseSymbol == "USD" &&
                el.convertSymbol == item.currencySymbol)
          );
          let pairIndex =
            tempArr &&
            tempArr.findIndex((el) => {
              return el._id == item._id;
            });
          if (pairIndex >= 0 && !isEmpty(pairIndex)) {
            let Balance = tempArr[pairIndex].balance;
            tempArr[pairIndex] = {
              ...tempArr[pairIndex],
              ...{
                image: item.image,
                decimals: item.decimals,
                status: item.status,
                type: item.type,
                USDValue: !isEmpty(PriceCnv?.convertPrice)
                  ? parseFloat(Balance * PriceCnv.convertPrice)
                  : Balance,
              },
            };
            totalAmount += tempArr[pairIndex].USDValue;
          }
        });

      if (defaultcurrency == "USD") {
        setTotalUSD(totalAmount);
      } else {
        let totalbalance = !isEmpty(PriceChange)
          ? parseFloat(totalAmount * PriceChange)
          : 0;
        setTotalUSD(totalbalance);
      }

      setWallet(tempArr);
      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.log("err:------ ", err);
    }
  };

  const handleCloseModal = () => {
    setExhangeData({ isModalOpen: false, record: {} });
  };

  const handleExchange = (item) => {
    // if (isExchange) {
    setExhangeData({
      isModalOpen: true,
      record: item?.item,
    });
    // } else {
    //     toastAlert("error", t("EXCHANGE_ACCESS"), "login");
    // }
  };

  useEffect(() => {
    if (
      !isEmpty(walletData) &&
      !isEmpty(currency) &&
      !isEmpty(priceConversion)
    ) {
      handleAsset();
    }
    if (defaultcurrency != "USD") {
      let convetCurrency =
        priceConversion &&
        priceConversion.length > 0 &&
        priceConversion.find(
          (el) => el.baseSymbol == "USD" && el.convertSymbol == defaultcurrency
        );
      if (convetCurrency?.convertPrice) {
        let amount = !isEmpty(convetCurrency?.convertPrice)
          ? parseFloat(convetCurrency?.convertPrice)
          : 1;
        setPriceChange(amount);
      } else {
        setPriceChange(0);
      }
    }
  }, [walletData, currency, priceConversion, defaultcurrency]);

  // console.log(Wallet, 'walletDatawalletData')
   const fetchData = () => {
        let array = []
        console.log("...wallet",walletData);
        
        walletData && walletData.length > 0 && walletData.map((item, key) => {
            let findata = currency && currency.find((el) => el._id == item._id);
           if(findata){
           if(item?._id.toString() === findata?._id.toString()){                
                array.push({
                value: findata?._id,
                label: findata?.currencySymbol,
                image: findata?.image,
                balance:truncateDecimals(item?.balance,findata?.decimals)
            })
            }
           }
         
            
        })
        setOption(array)
        const selectedCurrency = array.find ((option) => option.label === "USD" || option.label === "USDT");
        setSelectedOption(selectedCurrency)
       
    }
  useEffect(()=>{
    fetchData()
  },[activeTab,walletData])

  

  const handleSelect = (eventKey) => {
    const newSelectedOption = options.find(
      (option) => option.value === eventKey
    );
    setSelectedOption(newSelectedOption);
  };

  // const options = [
  //   { value: "USD", imageSrc: require("../../assets/images/crypto/usd.png") },
  //   { value: "BTC", imageSrc: require("../../assets/images/crypto/btc.png") },
  //   { value: "ETH", imageSrc: require("../../assets/images/crypto/eth.png") },
  //   { value: "USDT", imageSrc: require("../../assets/images/crypto/usdt.png") },
  // ];

  return (
    <>
      {/* <ExchangeModal
        isShow={exchangeData.isModalOpen}
        record={exchangeData.record}
        onHide={handleCloseModal}
      /> */}

      <div className="tab_wrapper">
        <div className="tab_header xs_scroll">
          <button
            className={activeTab === "deposit" ? "tab_btn active" : "tab_btn"}
            onClick={() => {
              setActiveTab("deposit");
              
            }}
          >
            <div>Deposit</div>
          </button>
          <button
            className={activeTab === "withdraw" ? "tab_btn active" : "tab_btn"}
            onClick={() => {
              setActiveTab("withdraw");
              
            }}
          >
            <div>Withdraw</div>
          </button>
          <button
            className={
              activeTab === "exchange" ? "tab_btn tab_three active" : "tab_btn "
            }
            onClick={() => setActiveTab("exchange")}
          >
            <div>Exchange</div>
          </button>
        </div>

        <div className="tab_content">
          <div className="staking_top_flex justify-content-start mt-2 mb-4">
            <div className="wallet_bal">
              <h4>
                {t("TOTAL_BALANCE")} :{" "}
                <span>
                  $ {/* {currencyChange(defaultcurrency)} */}
                  {showBalance ? (
                    <CurrencyFormat
                      displayType={"text"}
                      thousandSeparator={true}
                      value={truncateDecimals(totalUSD ? totalUSD : 0, 2)}
                    />
                  ) : (
                    "********"
                  )}
                </span>
              </h4>
              <i
                onClick={() => setshowBalance(showBalance ? false : true)}
                className={showBalance ? "bi bi-eye" : "bi bi-eye-slash"}
              ></i>
            </div>
            {/* <div className="wallet_page_right_flex">
              <div className="search_grp">
                <input
                  type="text"
                  placeholder={t("SEARCH")}
                  onChange={handleSearch}
                  className="form-control"
                />
                <img
                  src={require("../../assets/images/search_icon.png")}
                  alt="Search"
                  className="img-fluid search_icon"
                />
              </div>
              <div class="form-check">
                <input
                  class="form-check-input"
                  type="checkbox"
                  onClick={() => setCheck(check ? false : true)}
                />
                <label class="form-check-label" for="inlineCheckbox1">
                  {t("HIDE_ZERO_BALANCES")}
                </label>
              </div>
            </div> */}
          </div>

          {activeTab === "deposit" && (
            <>
              <div className="form-group">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <label class="form-label mb-0">{t("SELECT_ASSET")}</label>
                  <div>
                    <p className="mb-0">
                      {t("AVAILABLE_BALANCE")}:{selectedOption?.balance}
                    </p>
                  </div>
                </div>
                <Dropdown
                  onSelect={handleSelect}
                  className="image_dropdown_wrapper"
                >
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    className="image_dropdown"
                  >
                    <Image
                      src={selectedOption?.image}
                      alt={selectedOption?.value}
                      width={38}
                      height={38}
                    />
                    {selectedOption?.label}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {options
                      .filter((option) => option.value !== selectedOption.value) // exclude current
                      .map((option) => (
                        <Dropdown.Item
                          key={option.value}
                          eventKey={option.value}
                        >
                          <Image
                            src={option.image}
                            alt={option.label}
                            width={38}
                            height={38}
                          />{" "}
                          {option.label}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>  
              <Deposit coin={selectedOption?.label} />
             
            </>
          )}
          {activeTab === "withdraw" && (
            <>
              <div className="form-group">
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <label class="form-label mb-0">{t("SELECT_ASSET")}</label>
                  <div>
                    <p className="mb-0">
                      {t("AVAILABLE_BALANCE")}: {selectedOption?.balance}
                    </p>
                  </div>
                </div>
                <Dropdown
                  onSelect={handleSelect}
                  className="image_dropdown_wrapper"
                >
                  <Dropdown.Toggle
                    id="dropdown-basic"
                    className="image_dropdown"
                  >
                    <Image
                      src={selectedOption?.image}
                      alt={selectedOption?.label}
                      width={38}
                      height={38}
                    />
                    {selectedOption?.label}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    {options
                      .filter((option) => option.value !== selectedOption.value) // exclude current
                      .map((option) => (
                        <Dropdown.Item
                          key={option.value}
                          eventKey={option.value}
                        >
                          <Image
                            src={option.image}
                            alt={option.label}
                            width={38}
                            height={38}
                          />{" "}
                          {option.label}
                        </Dropdown.Item>
                      ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <Withdraw coin={selectedOption?.label} />

              
            </>
          )}
          {activeTab === "exchange" && (
            <>
            <ExchangeModal record={exchangeData.record}/>
             
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default WalletDetails;
